import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { ConsignOrderTable } from '../../components/ConsignOrder/ConsignOrderTable';

export const ConsignOrders = () => {
  const navigate = useNavigate();
  const {
    privileges: { consignmentOrder = [] },
    role = null,
  } = useSelector((state) => state.userAuth);

  return (
    <Card bordered={true} title={<TitleBreadcrumbs />} className="gx-card">
      {consignmentOrder.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate('/dashboard/ordenes-de-consigna/crear');
          }}
        >
          <PlusOutlined />
          Nuevo
        </Button>
      )}

      <ConsignOrderTable privileges={consignmentOrder} role={role} />
    </Card>
  );
};
